import React from 'react';
import { formatDietTypeLabel, normalizeDietType } from './onlineFoodItems';

function resolveDietVariant(foodType) {
    const normalized = normalizeDietType(foodType);
    if (normalized === 'NON-VEG') return 'nonveg';
    if (normalized === 'EGG') return 'egg';
    return 'veg';
}

export default function DietTypeSymbol({ foodType, className = '', size = 'md' }) {
    const variant = resolveDietVariant(foodType);
    const label = formatDietTypeLabel(foodType) || 'Veg';

    return (
        <span
            className={`diet-type-symbol diet-type-symbol--${variant} diet-type-symbol--${size} ${className}`.trim()}
            role="img"
            aria-label={label}
            title={label}
        >
            <span className="diet-type-symbol-inner" aria-hidden="true" />
        </span>
    );
}
